<script setup lang="ts">
import plural from 'plural-ru'

type HelpArticle = {
  id: number
  title: string
}

const props = withDefaults(
  defineProps<{
    articles?: HelpArticle[]
    category_code?: string
    category_id?: number
    category_name?: string
  }>(),
  {
    articles: () => []
  }
)

function formatPlural(val = 0, ...forms: [string, string, string]) {
  return `${val.toLocaleString()} ${plural(val, ...forms)}`
}
</script>

<template>
  <section class="help-category-section">
    <img class="help-category-section__icon" :src="`/help/category_image/${props.category_code}`" />

    <a :href="`/help/category/${props.category_code}`">
      <h2 class="help-category-section__title" v-text="props.category_name" />
    </a>

    <ul class="help-category-section__articles">
      <li v-for="article in props.articles.slice(0, 3)" :key="article.id">
        <a :href="`/help/article/${article.id}`">
          {{ article.title }}
        </a>
      </li>

      <li v-if="props.articles.length > 3">
        <a :href="`/help/category/${props.category_code}`" class="blue-text text-body-bold">
          Еще {{ formatPlural(props.articles.length - 3, 'статья', 'статьи', 'статей') }}

          <v-icon class="d-inline-flex">mdi-arrow-right</v-icon>
        </a>
      </li>
    </ul>
  </section>
</template>

<style lang="scss">
.help-category-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  &__icon {
    width: 64px;
    height: 64px;
    object-fit: contain;

    @include mobile {
      width: 40px;
      height: 40px;
    }
  }

  &__title {
    @include desktop {
      @include text-h3;
      margin-top: 24px;
    }

    @include mobile {
      @include text-title;
      font-weight: bold;
      margin-top: 16px;
    }

    transition: color 0.1s ease;

    &:hover {
      color: $blue;
    }
  }

  &__articles {
    @include desktop {
      margin-top: 16px;
    }
    @include mobile {
      margin-top: 12px;
    }

    & > li {
      &:not(:last-child) {
        @include desktop {
          margin-bottom: 12px;
        }
        @include mobile {
          margin-bottom: 8px;
        }
      }

      & > a {
        transition: color 0.1s ease;
        &:hover {
          color: $blue;
        }
      }
    }
  }
}
</style>
